/**
 * „Ein leises +18 blendet 600ms am gedrückten Knopf auf und verschwindet.
 *  Kein Popup, kein Konfetti, kein Ton." (DESIGN.md)
 *
 * Bei falscher MC-Antwort steht hier der Abzug in Fehlerfarbe.
 */
export function XpBlitz({ betrag }) {
  if (!betrag) return null
  const negativ = betrag < 0
  const text = negativ ? `−${Math.abs(betrag)}` : `+${betrag}`
  return (
    <span class={`xp-blitz ${negativ ? 'xp-blitz--minus' : ''}`} aria-live="polite">
      {text}
    </span>
  )
}
